// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MacCommandOutlinedSvg from "@fishx/icons-svg/es/asn/MacCommandOutlined";
import FishxIcon from '../components/FishxIcon';

var MacCommandOutlined = function MacCommandOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandOutlinedSvg
  }));
};

MacCommandOutlined.displayName = 'MacCommandOutlined';
export default React.forwardRef(MacCommandOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MacCommandOutlined.js
// module id = 3084
// module chunks = 0